import React, { FC, useContext, useMemo, useState } from 'react';
import { PasswordControl as PasswordControlCore } from 'ia-react-core';
import ChangePasswordContext from '../../../../utils/ChangePasswordContext';
import { getLanguage } from '../../../../utils/getLanguage';
import { buildValidators } from './buildValidators';
import { getOnChangePassword } from './getOnChangePassword';

export interface PasswordControlProps {
}

const PasswordControl: FC<PasswordControlProps> = () => {
  const { rules, setRules, sitecoreDictionary } = useContext(ChangePasswordContext);
  const [apiError, setApiError] = useState(null as string);
  const language = getLanguage();
  const validators = useMemo(() => buildValidators(rules, apiError), [rules, apiError]);
  const onChangePassword = useMemo(() => getOnChangePassword(language, setApiError, setRules), [language, setApiError, setRules]);

  return (
    <PasswordControlCore
      aria-labelledby="passwordLabel"
      maxErrorMessageRows={7}
      maxLength={64}
      name="password"
      required
      hidePasswordOnBlur
      onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) => { onChangePassword((e.target as HTMLInputElement).value); }}
      validators={validators}
      validationMessages={{
        isApiErrorMsg: apiError,
        isValidFormat: sitecoreDictionary?.getPhrase('password change', 'ERR_IB_PWD_SecurityPolicy', language),
        isFollowingChar: sitecoreDictionary?.getPhrase('password change', 'ERR_IB_PWD_FollowingCharacters', language),
        isSameChar: sitecoreDictionary?.getPhrase('password change', 'ERR_IB_PWD_RepetitiveCharacter', language),
        isErrorOnSubmit: rules?.ErrorMessageText?.length > 0 ? sitecoreDictionary?.getPhrase('password change', rules?.ErrorMessageText[0], language).replace(/<[^>]+>/g, '') : '',
      }}
    />

  );
};

export default PasswordControl;
